import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function SpinnerState({ className }: { className?: string } = {}) {
  return (
    <div className={cn("flex items-center justify-center", className)}>
      <Loader2 className="size-6 animate-spin text-muted-foreground" />
    </div>
  );
}

export function LoadingState({ message = "Loading..." }: { message?: string } = {}) {
  return (
    <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
      {message}
    </div>
  );
}

export function ErrorState({
  title,
  message,
  destructive = false,
}: {
  title: string;
  message: string;
  destructive?: boolean;
}) {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <h2 className={destructive ? "text-lg font-semibold text-destructive" : "text-lg font-semibold"}>
          {title}
        </h2>
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}

export function ExtractingState() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <Loader2 className="mx-auto mb-4 size-8 animate-spin text-muted-foreground" />
        <h2 className="text-lg font-semibold">Extracting Schedule Tags</h2>
        <p className="text-sm text-muted-foreground">
          The service is extracting schedule tables and deriving candidate tags.
        </p>
      </div>
    </div>
  );
}

export function CopyingRevisionState() {
  return (
    <div
      className="flex h-screen items-center justify-center"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <div className="text-center">
        <Loader2 className="mx-auto mb-4 size-8 animate-spin text-muted-foreground" />
        <h2 className="text-lg font-semibold">Copying Takeoff Revision</h2>
        <p className="text-sm text-muted-foreground">
          Measurements and schedule line items are being copied in safe batches.
        </p>
      </div>
    </div>
  );
}

export function DetailsErrorState() {
  return (
    <ErrorState
      title="Unable to load TakeoffPilot job"
      message="Failed to load job details. Please refresh and try again."
    />
  );
}

export function CountsErrorState() {
  return (
    <ErrorState
      title="Unable to load counting results"
      message="Failed to load persisted Takeoff counts. Please refresh and try again."
    />
  );
}
